import React from "react";
import {Box} from "@chakra-ui/react";
import Select from "react-select";


type OptionType = { label: string; value: string };

interface DatabasePropertiesSelectProps {
    options: string[];
    value: string | null;
    onChange: (selectedOption: OptionType | null) => void;
}

export const DropdownSelector: React.FC<DatabasePropertiesSelectProps> = ({
  options,
  value,
  onChange,
}) => {
  const formattedOptions: OptionType[] = options.map((option) => ({
    label: option,
    value: option,
  }));

  const handleChange = (selectedOption: OptionType | null) => {
    onChange(selectedOption);
  };

  return (
    <Box w={"full"} h={"full"}>
      <Select
        options={formattedOptions}
        value={{label: value, option: value}}
        isSearchable={false}
        menuPosition={"fixed"}
        onChange={handleChange}
        styles={{
          control: (base) => ({
            ...base,
            borderColor: 'gray.500', // Added this line to make all borders gray
          }),
          singleValue: base => ({
            ...base,

          }),
          menu: base => ({
            ...base,

          })
        }}
      />
    </Box>
  );
};